import type { HTMLAttributes } from 'react';

/** White editorial panel framed by a 1px #EEEEEE hairline. */
export function Panel(props: HTMLAttributes<HTMLElement>) {
  return <section {...props} className={['qm-panel', props.className].filter(Boolean).join(' ')} />;
}
